import React from 'react'

import classNames from 'classnames'

import './Card.scss'

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
  className?: string
}

export const Card: React.FC<CardProps> = ({ children, className, ...rest }) => {
  return (
    <div className={classNames('card wrapper', className)} {...rest}>
      {children}
    </div>
  )
}
